import {goBack, replace} from 'react-router-redux';
import {addApplicationMessage} from './applicationMessagesActions';

const REDIRECT_MESSAGE = 'You do not have sufficient permissions to view this page. If this is a mistake, please contact your administrator.';
const MISSING_MESSAGE = 'Could not find the specified route. Redirecting to home.';
const REDIRECT_MESSAGE_TYPE = 'error';

export function redirectWithMessage(newLocation) {
    return dispatch => {
        dispatch(replace(newLocation));
        dispatch(addApplicationMessage(REDIRECT_MESSAGE_TYPE, REDIRECT_MESSAGE));
    };
}

export function goBackWithMessage() {
    return dispatch => {
        dispatch(goBack());
        dispatch(addApplicationMessage(REDIRECT_MESSAGE_TYPE, REDIRECT_MESSAGE));
    };
}

export function couldNotFindRoute(newLocation) {
    return dispatch => {
        dispatch(replace(newLocation));
        dispatch(addApplicationMessage(REDIRECT_MESSAGE_TYPE, MISSING_MESSAGE));
    };
}